export interface CampaignConfig {
  soldOutEventId: string;
  targetEventId: string;
  discountCode: string;
  discountPercent: number;
  message: string;
  ctaText: string;
}

export const activeCampaigns: Record<string, CampaignConfig> = {
  secretSalon7: {
    soldOutEventId: "404ee842-4ac9-4789-977e-7d5b4222cc15", // Secret Salon #7
    targetEventId: "e0a2ce32-f82f-4e34-99df-d12fb1daf02c", // ✨ Gallery Stroll ✨ 4th October
    discountCode: "salon50",
    discountPercent: 50,
    message: "Sorry all spots for this Salon have been taken! 😢 To cheer you up, here's something special just for you...",
    ctaText: "Get 50% Off Gallery Stroll"
  }
  // Future campaigns can be easily added here
};

export function findCampaignForEvent(eventId: string): CampaignConfig | null {
  for (const campaign of Object.values(activeCampaigns)) {
    if (campaign.soldOutEventId === eventId) {
      return campaign;
    }
  }
  return null;
}

export function getCampaignByCode(discountCode: string): CampaignConfig | null {
  for (const campaign of Object.values(activeCampaigns)) {
    if (campaign.discountCode === discountCode) {
      return campaign;
    }
  }
  return null;
}
